import clsx from "clsx";
import moment from "moment";

import {
  DataTypeProvider,
  type DataTypeProviderProps,
} from "@devexpress/dx-react-grid";

type StatusType = "DRAFT" | "CURRENT" | "PAST" | "HIDDEN";

const statusClassNames = {
  CURRENT: "bg-alien-2 text-alien border border-alien",
  PAST: "bg-v2-secondary text-v2-primary border border-interstellar",
  DRAFT: "bg-cosmic-3 text-cosmic+1 border border-cosmic",
  HIDDEN: "bg-sun-2 text-saturn-1 border border-sun",
};

const StatusFormatter = ({ row }: DataTypeProvider.ValueFormatterProps) => {
  let status: StatusType = "CURRENT";

  if (row.state === "draft") {
    status = "DRAFT";
  } else if (row.hidden) {
    status = "HIDDEN";
  } else if (moment().isAfter(row.date_range.end_date)) {
    status = "PAST";
  }

  return (
    <div className="flex items-center justify-start">
      <div
        className={clsx(
          "rounded-md px-1.5 py-1 font-bold text-2xs",
          statusClassNames[status],
        )}
      >
        {status}
      </div>
    </div>
  );
};

export const StatusTypeProvider = (props: DataTypeProviderProps) => (
  <DataTypeProvider formatterComponent={StatusFormatter} {...props} />
);
